(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsnco-compare"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__tsnCmp) return;
    window.__tsnCmp = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      if (root.__cmp) return; root.__cmp = true;
      const stage = root.querySelector('[data-stage]');
      const range = root.querySelector('[data-range]');
      const btn = root.querySelector('[data-btn]');
      const btnText = root.querySelector('[data-btn-text]');
      let pos = Number(range.value) || 50, side = null;

      const set = (v, anim) => {
        pos = Math.max(0, Math.min(100, v));
        root.classList.toggle('is-anim', !!anim);
        root.style.setProperty('--pos', pos + '%');
        range.value = Math.round(pos);
        const now = pos >= 50 ? 'l' : 'r';
        root.classList.toggle('is-l', now === 'l');
        root.classList.toggle('is-r', now === 'r');
        if (now !== side) {
          side = now;
          range.setAttribute('aria-valuetext', now === 'l' ? root.dataset.l || '' : root.dataset.r || '');
          if (btn) {
            btn.href = btn.dataset['url' + (now === 'l' ? 'L' : 'R')];
            btnText.textContent = btn.dataset['label' + (now === 'l' ? 'L' : 'R')];
            btnText.classList.remove('is-swap'); void btnText.offsetWidth; btnText.classList.add('is-swap');
          }
        }
      };
      root.dataset.l = root.querySelector('.tsn-cmp__tag--l')?.textContent || '';
      root.dataset.r = root.querySelector('.tsn-cmp__tag--r')?.textContent || '';

      const fromX = (x) => { const r = stage.getBoundingClientRect(); return ((x - r.left) / r.width) * 100; };
      let dragging = false, sx = 0, sy = 0, decided = false;
      stage.addEventListener('pointerdown', (e) => {
        if (e.button !== 0) return;
        dragging = true; decided = e.pointerType === 'mouse'; sx = e.clientX; sy = e.clientY;
        if (decided) { root.classList.add('is-drag'); set(fromX(e.clientX), false); stage.setPointerCapture(e.pointerId); }
      });
      stage.addEventListener('pointermove', (e) => {
        if (!dragging) return;
        if (!decided) {
          const dx = Math.abs(e.clientX - sx), dy = Math.abs(e.clientY - sy);
          if (dx < 6 && dy < 6) return;
          if (dy > dx) { dragging = false; return; }
          decided = true; root.classList.add('is-drag'); stage.setPointerCapture(e.pointerId);
        }
        set(fromX(e.clientX), false);
      });
      const end = (e) => {
        if (dragging && !decided && e.type === 'pointerup') set(fromX(e.clientX), true);
        dragging = false; root.classList.remove('is-drag');
      };
      stage.addEventListener('pointerup', end);
      stage.addEventListener('pointercancel', end);
      range.addEventListener('input', () => set(Number(range.value), false));
      root.querySelectorAll('[data-go]').forEach((c) => c.addEventListener('click', () => set(Number(c.dataset.go), true)));

      set(pos, false);

      // Convite: um leve "vai e volta" na primeira vez que a seção aparece.
      if (!reduce && 'IntersectionObserver' in window) {
        const io = new IntersectionObserver((ents) => {
          if (!ents[0].isIntersecting) return;
          io.disconnect();
          const base = pos;
          setTimeout(() => set(base - 14, true), 350);
          setTimeout(() => set(base + 10, true), 1050);
          setTimeout(() => set(base, true), 1750);
        }, { threshold: .55 });
        io.observe(stage);
      }
    }

    const boot = (scope = document) => scope.querySelectorAll('[data-tsn-cmp]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
    else boot();
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsnco-countdown"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__tsnCountdown) return;
    window.__tsnCountdown = true;
    const pad = (n) => String(n).padStart(2, '0');

    function init(root) {
      if (root.__tsnCd) return;
      root.__tsnCd = true;
      const target = Date.parse(root.dataset.target);
      const clock = root.querySelector('[data-clock]');
      const msg = root.querySelector('[data-ended-msg]');
      const els = {};
      root.querySelectorAll('[data-u]').forEach((el) => (els[el.dataset.u] = el));
      const inEditor = !!(window.Shopify && window.Shopify.designMode);

      const set = (k, v) => {
        const el = els[k];
        if (!el || el.textContent === v) return;
        el.textContent = v;
        el.classList.remove('is-tick'); void el.offsetWidth; el.classList.add('is-tick');
      };

      const tick = () => {
        if (!root.isConnected) return clearInterval(timer);
        if (Number.isNaN(target)) return;
        let left = Math.max(0, Math.floor((target - Date.now()) / 1000));
        const d = Math.floor(left / 86400); left -= d * 86400;
        const h = Math.floor(left / 3600); left -= h * 3600;
        const m = Math.floor(left / 60); const s = left - m * 60;
        set('d', pad(d)); set('h', pad(h)); set('m', pad(m)); set('s', pad(s));
        if (target - Date.now() <= 0) {
          clearInterval(timer);
          const mode = root.dataset.ended;
          if (mode === 'hide' && !inEditor) {
            const sec = root.closest('.shopify-section');
            (sec || root).style.display = 'none';
          } else if (mode === 'message') {
            if (clock) clock.hidden = true;
            if (msg) msg.hidden = false;
          }
        }
      };
      const timer = setInterval(tick, 1000);
      tick();
    }

    const boot = (scope = document) => scope.querySelectorAll('[data-tsn-countdown]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
    else boot();
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsnco-festas"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const canHover = window.matchMedia('(hover: hover) and (pointer: fine)');
    const wait = (ms) => new Promise((r) => setTimeout(r, ms));

    function init(root) {
      if (!root || root.dataset.fxReady) return;
      root.dataset.fxReady = '1';
      const slides = [...root.querySelectorAll('.tsn-fx__slide')];
      const pills = [...root.querySelectorAll('[data-pill]')];
      const chip = root.querySelector('.tsn-fx__chip');
      const typed = root.querySelector('[data-typed]');
      const words = JSON.parse(root.querySelector('script[data-fx-words]')?.textContent || '[]');
      const interval = Math.max(1500, parseInt(root.dataset.interval, 10) || 2000);
      let cur = 0, target = 0, typing = false, visible = false, timer = null, holdUntil = 0;

      const play = () => {
        slides.forEach((s, n) => s.querySelectorAll('video').forEach((v) => {
          const shown = getComputedStyle(v).display !== 'none';
          if (n === cur && visible && shown) v.play().catch(() => {}); else v.pause();
        }));
      };

      // Digita a palavra da cena; se trocar no meio, continua para a última pedida.
      async function type() {
        if (typing || !typed) return;
        typing = true;
        chip && chip.classList.add('is-typing');
        while (true) {
          const want = words[target] || '';
          let t = typed.textContent;
          if (t === want) break;
          if (want.startsWith(t)) { typed.textContent = want.slice(0, t.length + 1); await wait(40); }
          else { typed.textContent = t.slice(0, -1); await wait(18); }
        }
        chip && chip.classList.remove('is-typing');
        typing = false;
      }

      const show = (k) => {
        if (k < 0 || k >= slides.length) return;
        target = k;
        if (k !== cur) {
          cur = k;
          slides.forEach((s, n) => s.classList.toggle('is-on', n === k));
          pills.forEach((p) => p.classList.toggle('is-active', +p.dataset.pill === k));
          play();
        }
        if (reduce) { if (typed) typed.textContent = words[k] || ''; } else { type(); }
      };

      // Computador: passar o mouse (ou focar) na pílula troca a cena.
      pills.forEach((p) => {
        const k = +p.dataset.pill;
        p.addEventListener('mouseenter', () => { if (canHover.matches) show(k); });
        p.addEventListener('focus', () => show(k));
        // Celular: tocar numa pílula troca a cena; tocar de novo na mesma abre o par.
        p.addEventListener('click', (e) => {
          if (canHover.matches) return;
          if (k !== cur || !p.getAttribute('href')) { e.preventDefault(); show(k); pulse(p); holdUntil = Date.now() + 8000; }
        });
      });

      const pulse = (p) => {
        if (!p || reduce) return;
        p.classList.remove('is-pulse'); void p.offsetWidth; p.classList.add('is-pulse');
        setTimeout(() => p.classList.remove('is-pulse'), 750);
      };

      // Celular: as pílulas pulsam sozinhas, uma por vez, e o pulso troca o fundo.
      const tick = () => {
        clearTimeout(timer);
        if (!visible || canHover.matches || slides.length < 2) return;
        timer = setTimeout(() => {
          if (Date.now() >= holdUntil) {
            const k = (cur + 1) % slides.length;
            const p = pills.find((x) => +x.dataset.pill === k);
            pulse(p);
            setTimeout(() => show(k), reduce ? 0 : 220);
          }
          tick();
        }, interval);
      };

      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          visible = e.isIntersecting;
          if (visible) root.classList.add('is-in');
          play();
          tick();
        });
      }, { threshold: 0.3 });
      io.observe(root);
      canHover.addEventListener?.('change', tick);
      document.addEventListener('visibilitychange', () => { if (document.hidden) clearTimeout(timer); else tick(); });

      root.closest('.shopify-section')?.addEventListener('shopify:block:select', (e) => {
        const k = slides.findIndex((s) => s === e.target || s.contains(e.target));
        if (k > -1) { holdUntil = Date.now() + 15000; show(k); }
      });
    }

    const boot = () => document.querySelectorAll('[data-tsn-fx]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsnco-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // No celular os menus começam fechados (sanfona); no computador ficam sempre abertos.
    const sync = () => {
      const mobile = window.matchMedia('(max-width: 749px)').matches;
      document.querySelectorAll('.tsn-foot__card--menu').forEach((d) => {
        if (!mobile) d.open = true;
        else if (!d.__tsnTouched) d.open = false;
      });
    };
    document.addEventListener('toggle', (e) => {
      if (e.target.classList && e.target.classList.contains('tsn-foot__card--menu')) e.target.__tsnTouched = true;
    }, true);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
    window.matchMedia('(max-width: 749px)').addEventListener('change', sync);
    document.addEventListener('shopify:section:load', sync);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsnco-inspired"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__tsnInsp) return;
    window.__tsnInsp = true;

    const closeSpots = (scope, except) => {
      (scope || document).querySelectorAll('.tsn-spot.is-open').forEach((sp) => {
        if (sp === except) return;
        sp.classList.remove('is-open');
        sp.querySelector('.tsn-spot__dot')?.setAttribute('aria-expanded', 'false');
      });
    };

    function initSpots(root) {
      const hoverable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      root.querySelectorAll('[data-spot]').forEach((sp) => {
        const dot = sp.querySelector('.tsn-spot__dot');
        const open = (v) => {
          if (v) closeSpots(root, sp);
          sp.classList.toggle('is-open', v);
          dot.setAttribute('aria-expanded', v ? 'true' : 'false');
        };
        dot.addEventListener('click', (e) => { e.preventDefault(); e.stopPropagation(); open(!sp.classList.contains('is-open')); });
        if (hoverable) {
          let t;
          sp.addEventListener('mouseenter', () => { clearTimeout(t); open(true); });
          sp.addEventListener('mouseleave', () => { t = setTimeout(() => open(false), 260); });
        }
        sp.querySelector('.tsn-spot__card')?.addEventListener('click', (e) => e.stopPropagation());
        ['touchstart', 'touchend'].forEach((ev) => sp.addEventListener(ev, (e) => e.stopPropagation(), { passive: true }));
      });
      document.addEventListener('click', () => closeSpots(root));
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeSpots(root); });
    }

    function init(root) {
      if (root.__tsnInsp) return;
      root.__tsnInsp = true;
      initSpots(root);
      const chs = [...root.querySelectorAll('.tsn-insp__ch')];
      if (chs.length < 2) return;
      const label = root.querySelector('[data-label-out]');
      const dots = [...root.querySelectorAll('.tsn-insp__dots i')];
      let i = 0;

      const go = (n) => {
        const prev = chs[i];
        i = (n + chs.length) % chs.length;
        const next = chs[i];
        if (prev === next) return;
        closeSpots(root);
        prev.classList.remove('is-on'); prev.setAttribute('aria-hidden', 'true');
        prev.querySelectorAll('a, button').forEach((a) => a.setAttribute('tabindex', '-1'));
        next.classList.add('is-on'); next.removeAttribute('aria-hidden');
        next.querySelectorAll('a, button').forEach((a) => a.removeAttribute('tabindex'));
        if (label) {
          label.textContent = next.dataset.label || '';
          label.classList.remove('is-swap'); void label.offsetWidth; label.classList.add('is-swap');
        }
        dots.forEach((d, k) => d.classList.toggle('is-on', k === i));
      };
      root.__go = (n) => go(n);

      root.querySelector('[data-next]')?.addEventListener('click', () => go(i + 1));
      root.querySelector('[data-prev]')?.addEventListener('click', () => go(i - 1));
      root.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') go(i + 1);
        if (e.key === 'ArrowLeft') go(i - 1);
      });

      const stage = root.querySelector('.tsn-insp__stage');
      let sx = null, sy = null;
      stage.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (sx === null) return;
        const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1));
        sx = sy = null;
      });
    }

    const boot = (scope = document) => scope.querySelectorAll('[data-tsn-insp]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
    else boot();
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
    document.addEventListener('shopify:block:select', (e) => {
      const ch = e.target.closest && e.target.closest('.tsn-insp__ch');
      const root = ch && ch.closest('[data-tsn-insp]');
      if (root && root.__go) root.__go([...root.querySelectorAll('.tsn-insp__ch')].indexOf(ch));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsnco-looks"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__tsnLooks) return;
    window.__tsnLooks = true;

    function init(root) {
      if (root.__tsnLooks) return;
      root.__tsnLooks = true;
      const looksNow = () => [...root.querySelectorAll('[data-look]')];
      let i = Math.max(0, looksNow().findIndex((l) => l.classList.contains('is-on')));

      const go = (n, focusTab) => {
        const looks = looksNow();
        if (!looks.length) return;
        i = (n + looks.length) % looks.length;
        looks.forEach((l, k) => {
          const on = k === i;
          l.classList.toggle('is-on', on);
          on ? l.removeAttribute('aria-hidden') : l.setAttribute('aria-hidden', 'true');
          l.querySelectorAll('a, button').forEach((el) => (on ? el.removeAttribute('tabindex') : el.setAttribute('tabindex', '-1')));
        });
        root.querySelectorAll('[data-tab]').forEach((t, k) => {
          t.classList.toggle('is-on', k === i);
          t.setAttribute('aria-selected', k === i);
          if (k === i && focusTab !== false) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
        });
        root.querySelectorAll('.tsn-looks__dots i').forEach((d, k) => d.classList.toggle('is-on', k === i));
      };
      root.__go = go;

      root.addEventListener('click', (e) => {
        const tab = e.target.closest('[data-tab]');
        if (tab) return go(Number(tab.dataset.tab));
        if (e.target.closest('[data-next]')) return go(i + 1);
        if (e.target.closest('[data-prev]')) return go(i - 1);
        const z = e.target.closest('[data-zoom]');
        if (z) {
          const img = z.querySelector('img');
          const dlg = root.querySelector('[data-dialog]');
          if (!img || !dlg || !dlg.showModal) return;
          const full = dlg.querySelector('[data-full]');
          const src = (img.currentSrc || img.src).replace(/([?&]width=)\d+/, (m, k) => k + '1600');
          full.src = src; full.alt = img.alt;
          dlg.showModal();
          return;
        }
        if (e.target.closest('[data-close]') || e.target.matches('[data-dialog]')) root.querySelector('[data-dialog]')?.close();
      });

      let sx = null, sy = null;
      const stage = root.querySelector('.tsn-looks__stage');
      stage.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      stage.addEventListener('touchend', (e) => {
        if (sx === null) return;
        const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(i + (dx < 0 ? 1 : -1));
        sx = sy = null;
      });
      root.addEventListener('keydown', (e) => {
        if (e.target.closest('[data-dialog]')) return;
        if (e.key === 'ArrowRight') go(i + 1);
        if (e.key === 'ArrowLeft') go(i - 1);
      });
    }

    const boot = (scope = document) => scope.querySelectorAll('[data-tsn-looks]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
    else boot();
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
    document.addEventListener('shopify:block:select', (e) => {
      const look = e.target.closest && e.target.closest('[data-look]');
      const root = look && look.closest('[data-tsn-looks]');
      if (root && root.__go) root.__go([...root.querySelectorAll('[data-look]')].indexOf(look), false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsnco-process"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__tsnProc) return;
    window.__tsnProc = true;

    function init(root) {
      if (root.__tsnProc) return;
      root.__tsnProc = true;
      const rail = root.querySelector('[data-rail]');
      const bar = root.querySelector('[data-bar]');
      const thumb = bar && bar.querySelector('[data-thumb]');
      const cards = [...rail.querySelectorAll('.tsn-proc__card')];

      const update = () => {
        const max = rail.scrollWidth - rail.clientWidth;
        const ratio = max > 0 ? rail.scrollLeft / max : 0;
        const w = Math.max(.15, Math.min(1, rail.clientWidth / rail.scrollWidth));
        if (thumb) { thumb.style.width = (w * 100) + '%'; thumb.style.left = (ratio * (1 - w) * 100) + '%'; }
        if (bar) bar.style.visibility = max > 2 ? 'visible' : 'hidden';
        const left = rail.getBoundingClientRect().left + parseFloat(getComputedStyle(rail).scrollPaddingLeft || 0);
        let best = 0, d = Infinity;
        cards.forEach((c, k) => { const dd = Math.abs(c.getBoundingClientRect().left - left); if (dd < d) { d = dd; best = k; } });
        if (max > 0 && ratio > .98) best = cards.length - 1;
        cards.forEach((c, k) => c.classList.toggle('is-on', k === best));
      };
      let raf = 0;
      rail.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', update);
      update();

      if (bar) {
        const seek = (x) => {
          const r = bar.getBoundingClientRect();
          const ratio = Math.min(1, Math.max(0, (x - r.left) / r.width));
          rail.scrollTo({ left: ratio * (rail.scrollWidth - rail.clientWidth), behavior: 'auto' });
        };
        bar.addEventListener('pointerdown', (e) => {
          bar.setPointerCapture(e.pointerId); bar.classList.add('is-drag');
          rail.style.scrollSnapType = 'none'; seek(e.clientX);
        });
        bar.addEventListener('pointermove', (e) => { if (bar.classList.contains('is-drag')) seek(e.clientX); });
        const end = () => { bar.classList.remove('is-drag'); rail.style.scrollSnapType = ''; };
        bar.addEventListener('pointerup', end); bar.addEventListener('pointercancel', end);
      }

      rail.addEventListener('keydown', (e) => {
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        e.preventDefault();
        const step = (cards[0]?.getBoundingClientRect().width || 300) + 12;
        rail.scrollBy({ left: e.key === 'ArrowRight' ? step : -step, behavior: 'smooth' });
      });

      // Vídeos tocam só quando aparecem na tela
      const vids = [...root.querySelectorAll('video')];
      if (vids.length && 'IntersectionObserver' in window) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const io = new IntersectionObserver((entries) => {
          entries.forEach((en) => {
            const v = en.target;
            if (en.isIntersecting && en.intersectionRatio > .4 && !reduce) { v.muted = true; v.play().catch(() => {}); }
            else v.pause();
          });
        }, { threshold: [0, .4, .8] });
        vids.forEach((v) => io.observe(v));
      }
    }

    const boot = (scope = document) => scope.querySelectorAll('[data-tsn-proc]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
    else boot();
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
    document.addEventListener('shopify:block:select', (e) => {
      const card = e.target.closest && e.target.closest('.tsn-proc__card');
      const rail = card && card.closest('[data-rail]');
      if (rail) rail.scrollTo({ left: card.offsetLeft - rail.offsetLeft - parseFloat(getComputedStyle(rail).paddingLeft || 0), behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsnco-store"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__tsnStore) return;
    window.__tsnStore = true;

    function setupCard(card) {
      if (card.__tsnStore) return;
      card.__tsnStore = true;
      const gallery = card.querySelector('[data-gallery]');
      const map = card.querySelector('[data-map]');
      const views = [...card.querySelectorAll('[data-view]')];
      const slides = [...card.querySelectorAll('[data-slide]')];
      const idxEl = card.querySelector('[data-idx]');
      let i = 0;

      const show = (n) => {
        if (!slides.length) return;
        const dir = n > i ? 1 : -1;
        const next = (n + slides.length) % slides.length;
        if (next === i) return;
        slides[i].classList.remove('is-on');
        slides[i].classList.toggle('is-up', dir > 0);
        i = next;
        slides[i].classList.remove('is-up');
        slides[i].classList.add('is-on');
        if (idxEl) idxEl.textContent = i + 1;
      };
      card.querySelector('[data-next]')?.addEventListener('click', () => show(i + 1));
      card.querySelector('[data-prev]')?.addEventListener('click', () => show(i - 1));
      if (slides.length < 2) card.querySelector('.tsn-store__arrows')?.setAttribute('hidden', '');

      let sy = null, sx = null;
      gallery.addEventListener('touchstart', (e) => { sx = e.touches[0].clientX; sy = e.touches[0].clientY; }, { passive: true });
      gallery.addEventListener('touchend', (e) => {
        if (sx === null) return;
        const dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) show(i + (dx < 0 ? 1 : -1));
        sx = sy = null;
      });

      views.forEach((btn) => btn.addEventListener('click', () => {
        const v = btn.dataset.view;
        views.forEach((b) => { const on = b === btn; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on); });
        gallery.hidden = v !== 'gallery';
        map.hidden = v !== 'map';
        if (v === 'map') {
          const f = map.querySelector('iframe[data-src]');
          if (f && !f.src) f.src = f.dataset.src;
        }
      }));
    }

    function init(root) {
      root.querySelectorAll('[data-store]').forEach(setupCard);
      if (root.__tsnStoreTabs) return;
      root.__tsnStoreTabs = true;
      const tabs = [...root.querySelectorAll('[data-tab]')];
      const cards = [...root.querySelectorAll('[data-store]')];
      const pick = (k) => {
        tabs.forEach((t, j) => { t.classList.toggle('is-on', j === k); t.setAttribute('aria-selected', j === k); });
        cards.forEach((c, j) => { c.hidden = j !== k; c.classList.toggle('is-on', j === k); });
      };
      root.__pick = pick;
      tabs.forEach((t, k) => t.addEventListener('click', () => pick(k)));
    }

    const boot = (scope = document) => scope.querySelectorAll('[data-tsn-store]').forEach(init);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
    else boot();
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
    document.addEventListener('shopify:block:select', (e) => {
      const card = e.target.closest && e.target.closest('[data-store]');
      const root = card && card.closest('[data-tsn-store]');
      if (root && root.__pick) root.__pick([...root.querySelectorAll('[data-store]')].indexOf(card));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsnco-story"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__tsnStory) return;
    window.__tsnStory = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Conta do zero até o número quando o card aparece. Mantém prefixo/sufixo ("+90", "33–41", "100%").
    const run = (el) => {
      if (el.__done) return; el.__done = true;
      const txt = el.textContent.trim();
      const m = txt.match(/^(\D*)(\d+)(.*)$/);
      if (!m || reduce) return;
      const [, pre, num, post] = m; const end = parseInt(num, 10);
      if (end < 2 || /\d/.test(post)) return;
      const t0 = performance.now(), dur = 1100;
      const tick = (t) => {
        const k = Math.min(1, Math.max(0, (t - t0) / dur)), e = 1 - Math.pow(1 - k, 3);
        el.textContent = pre + Math.round(end * e) + post;
        if (k < 1) requestAnimationFrame(tick); else el.textContent = txt;
      };
      requestAnimationFrame(tick);
    };

    // Vídeo do "Feito com intenção": toca sem som, pausa fora da tela e respeita "reduzir movimento".
    const initVideo = (box) => {
      if (box.__v) return; box.__v = true;
      const v = box.querySelector('video'), btn = box.querySelector('[data-vbtn]');
      if (!v) return;
      v.muted = true; v.setAttribute('muted', '');
      let user = reduce;
      const sync = () => { if (!btn) return; btn.classList.toggle('is-paused', v.paused); btn.setAttribute('aria-label', v.paused ? 'Tocar vídeo' : 'Pausar vídeo'); };
      v.addEventListener('play', sync); v.addEventListener('pause', sync);
      if (reduce) { v.removeAttribute('autoplay'); v.pause(); }
      btn?.addEventListener('click', () => { if (v.paused) { user = false; v.play().catch(() => {}); } else { user = true; v.pause(); } });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver((ents) => ents.forEach((en) => {
          if (en.isIntersecting) { if (!user) v.play().catch(() => {}); } else v.pause();
        }), { threshold: .25 }).observe(box);
      }
      sync();
    };

    const boot = (scope = document) => {
      scope.querySelectorAll('[data-tsn-story] [data-story-video]').forEach(initVideo);
      const els = scope.querySelectorAll('[data-tsn-story] [data-count]');
      if (!('IntersectionObserver' in window)) return;
      const io = new IntersectionObserver((ents) => ents.forEach((en) => {
        if (en.isIntersecting) { run(en.target); io.unobserve(en.target); }
      }), { threshold: .6 });
      els.forEach((el) => io.observe(el));
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
    else boot();
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsnco-timeline"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__tsnTl) return;
    window.__tsnTl = true;
    const roots = new Set();
    const tick = () => {
      roots.forEach((root) => {
        const list = root.querySelector('.tsn-tl__list');
        if (!list) return;
        const r = list.getBoundingClientRect(), vh = window.innerHeight;
        const p = Math.max(0, Math.min(1, (vh * 0.6 - r.top) / r.height));
        list.style.setProperty('--tl-p', (p * 100).toFixed(1) + '%');
      });
    };
    const boot = (scope = document) => { scope.querySelectorAll('[data-tsn-tl]').forEach((r) => roots.add(r)); tick(); };
    window.addEventListener('scroll', () => requestAnimationFrame(tick), { passive: true });
    window.addEventListener('resize', tick);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
    else boot();
    document.addEventListener('shopify:section:load', (e) => boot(e.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tsnco-vip"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const boot = () => document.querySelectorAll('.tsn-vip:not(.is-in)').forEach((el) => {
      if (!('IntersectionObserver' in window)) { el.classList.add('is-in'); return; }
      const io = new IntersectionObserver((es) => es.forEach((e) => { if (e.isIntersecting) { el.classList.add('is-in'); io.disconnect(); } }), { threshold: .35 });
      io.observe(el);
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
